export const yardList = [
  {
    id: 1,
    yardName: "Production Yard",
    yardLocation: "Bangalore",
  },
  {
    id: 2,
    yardName: "Procurement Yard",
    yardLocation: "Chennai",
  },
  {
    id: 3,
    yardName: "Stock Yard",
    yardLocation: "Coimbatore",
  },
  {
    id: 4,
    yardName: "Tool Yard",
    yardLocation: "Hyderabad",
  },
  {
    id: 5,
    yardName: "Material Yard",
    yardLocation: "Kolkata",
  },
];

const yards = [
  {
    id: 1,
    yardName: "Production Yard",
    yardLocation: "Bangalore",
    stockItems: [
      {
        id: 1,
        itemName: "Bricks",
        count: 1500,
      },
      {
        id: 2,
        itemName: "Paint",
        count: 300,
      },
      {
        id: 3,
        itemName: "Tiles",
        count: 800,
      },
      {
        id: 4,
        itemName: "Scaffolding",
        count: 100,
      },
      {
        id: 5,
        itemName: "Crane",
        count: 5,
      },
    ],
  },
  {
    id: 2,
    yardName: "Procurement Yard",
    yardLocation: "Chennai",
    stockItems: [
      {
        id: 1,
        itemName: "Pipes",
        count: 200,
      },
      {
        id: 2,
        itemName: "Electrical Cables",
        count: 400,
      },
      {
        id: 3,
        itemName: "Concrete Mix",
        count: 1000,
      },
      {
        id: 4,
        itemName: "Safety Equipment",
        count: 50,
      },
      {
        id: 5,
        itemName: "Heavy Vehicles",
        count: 3,
      },
    ],
  },
  {
    id: 3,
    yardName: "Stock Yard",
    yardLocation: "Coimbatore",
    stockItems: [
      {
        id: 1,
        itemName: "Sand",
        count: 5000,
      },
      {
        id: 2,
        itemName: "Gravel",
        count: 2500,
      },
      {
        id: 3,
        itemName: "Iron Rods",
        count: 1200,
      },
      {
        id: 4,
        itemName: "Steel Beams",
        count: 500,
      },
      {
        id: 5,
        itemName: "Concrete Blocks",
        count: 1000,
      },
    ],
  },
  {
    id: 4,
    yardName: "Tool Yard",
    yardLocation: "Hyderabad",
    stockItems: [
      {
        id: 1,
        itemName: "Wrench",
        count: 50,
      },
      {
        id: 2,
        itemName: "Planes",
        count: 10,
      },
      {
        id: 3,
        itemName: "Drills",
        count: 20,
      },
      {
        id: 4,
        itemName: "Saws",
        count: 15,
      },
      {
        id: 5,
        itemName: "Measuring Tapes",
        count: 25,
      },
    ],
  },
  {
    id: 5,
    yardName: "Material Yard",
    yardLocation: "Kolkata",
    stockItems: [
      {
        id: 1,
        itemName: "Bricks",
        count: 1500,
      },
      {
        id: 2,
        itemName: "Paint",
        count: 300,
      },
      {
        id: 3,
        itemName: "Tiles",
        count: 800,
      },
      {
        id: 4,
        itemName: "Steel Beams",
        count: 500,
      },
      {
        id: 5,
        itemName: "Concrete Blocks",
        count: 1000,
      },
    ],
  },
];

export const StockService = {
  getYards: () => {
    return yardList;
  },

  getYard: (id) => {
    return yards.find((yard) => yard.id === id);
  },

  createYard: (payload) => {
    yards.push(payload);
  },

  getStockItems: (id) => {
    return yards.find((yard) => yard.id === id).stockItems;
  },
};
